/// <amd-module name="VSSUI/Components/HubHeader/HubTitle" />

import * as React from "react";
import { BaseComponent } from "OfficeFabric/Utilities";
import { css } from "VSSUI/Util";
import { IHubTitleProps } from "../../Components/HubHeader/HubTitle.Props";
import { IVssIconProps, VssIcon } from "VSSUI/VssIcon";

import "VSS/LoaderPlugins/Css!VSSUI/Components/HubHeader/HubTitle";

/** @deprecated */
export interface IHubTitleState {
    isFavorited?: boolean;
}

/**
 * Component that generates a standard VSTS page header.
 */
/** @deprecated */
export class HubTitle extends BaseComponent<IHubTitleProps, IHubTitleState> {
    constructor(props: IHubTitleProps) {
        super(props);
    }

    private getIcon() {
        if (this.props.iconProps) {
            const iconProps: IVssIconProps = { ...this.props.iconProps, className: css(this.props.iconProps.className, "vss-HubTitle-titleIcon") };
            return <VssIcon {...iconProps} />;
        }
        return null;
    }

    private getTitleText() {
        return <div className="vss-HubTitle--titleText">{this.props.titleText}</div>;
    }

    public render(): JSX.Element {
        const className = css("vss-HubTitle");

        return (
            <h1 className={className} onClick={this.props.onClick}>
                {this.getIcon()}
                {this.getTitleText()}
            </h1>
        );
    }
}
